import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useTbTestGuidedUploadEnabled() {
  return useCbhFlag(CbhFeatureFlag.RELEASE_TB_TEST_GUIDED_UPLOAD, {
    defaultValue: false,
  });
}
